import organizationTemplate from './organization.html';

/*****************************************************************************
 * @module  csm.books.OurOrg
 * @name    csm.books.OurOrg.component:organization
 * @ngDoc   Component
 *
 * @description
 * This component displays the organization information in Our School, Our PTA
 * and Our Booster. Settings for the different organization types are passed in
 * to this component using the AppConfig provider. This allows certain elements
 * to be hiden/displayed for each org type.
 *****************************************************************************/
export const organizationComponent = {
  template: organizationTemplate,
  controller: OrgController
};

/*****************************************************************************
* Controller: OrgController
/**
* @ngdoc    controller
* @module   csm.books.OurOrg
* @name     csm.books.OurOrg.controller:OrgControler
*
* @description
* Controller for the organization information. Displays and saves organization
* information in Our School, Our PTA and Our Booster.
*****************************************************************************/
/* @ngInject */ function OrgController(
  $injector,
  $q,
  Services,
  AppConfig,
  NewBooksData,
  BusyScreen
) {
  var $ctrl = this;
  $ctrl.valGroup = {};
  $ctrl.settings = AppConfig.settings;

  $q.all({
    org: Services.getOrganization(),
    bankAccounts: Services.getBankAccounts()
  }).then(function (promises) {
    (($ctrl.org = new NewBooksData.entities.Organization(promises.org)),
      ($ctrl.bankAccts = promises.bankAccounts.map(function (a) {
        return new NewBooksData.accounts.AccountAdminInfo(a);
      })),
      ($ctrl.grades = [
        { exitGrade: 12 },
        { exitGrade: 11 },
        { exitGrade: 10 },
        { exitGrade: 9 },
        { exitGrade: 8 },
        { exitGrade: 7 },
        { exitGrade: 6 },
        { exitGrade: 5 },
        { exitGrade: 4 },
        { exitGrade: 3 },
        { exitGrade: 2 },
        { exitGrade: 1 }
      ]));

    BusyScreen.setBusy(false);
  });

  /*---------*/
  /* Methods */
  /*---------*/
  $ctrl.handleLogo = $injector.invoke(handleLogo, null, { $ctrl: $ctrl });
  $ctrl.saveOrganization = $injector.invoke(saveOrganization, null, {
    $ctrl: $ctrl
  });
  $ctrl.taxRateDisplay = $injector.invoke(taxRateDisplay, null, {
    $ctrl: $ctrl
  });
}

/*****************************************************************************
 * $ctrl.handleLogo */
/**
 * @ngdoc     function
 * @name      handleLogo
 * @methodOf  csm.books.OurOrg.controller:OrgController
 *
 * @description
 * Opens the Image loader dialog for uploading a new school logo. Dispatches
 * logo-changed event for changes.
 *****************************************************************************/
/* @ngInject */ function handleLogo(
  $ctrl,
  BooksTools,
  SERVER,
  $rootScope,
  BooksEvents
) {
  return function () {
    BooksTools.showImageLoaderPanel(
      SERVER.BooksDBConstants.UIT_LOGO,
      { orgID: SERVER.currentUser.orgID },
      `${$ctrl.settings.displayName} Logo`,
      function () {
        $rootScope.$broadcast(BooksEvents.LOGO_CHANGED);
      }
    );
  };
}

/*****************************************************************************
 * $ctrl.saveOrganization */
/**
 * @ngdoc    function
 * @name     saveOrganization
 * methodOf  csm.books.OurOrg.controller.OrgController
 *
 * @description
 * Saves the Organization Information.
 *****************************************************************************/
/* @ngInject */ function saveOrganization($ctrl, Alert, Services, BusyScreen) {
  return function () {
    if (!$ctrl.valGroup.validate()) return;

    /*-------------------------------------------------------------------------*/
    /* We need to strip out all non digits (particularly the dashes used in    */
    /* FEIN's) of the FEIN and make it null if the field is an empty string.   */
    /* This is done becuase it is an int on the server.                        */
    /*                                                                         */
    /* TODO - Make changes to database to allow for the formatting of the EIN. */
    /* Also, an EIN can start with a zero and we need to store that as well.   */
    /*-------------------------------------------------------------------------*/
    $ctrl.org.FEIN =
      Number((String($ctrl.org.FEIN) || '').replace(/\D/g, '')) || null;

    /*-----------------------------------------------------------------------*/
    /* I am using this check instead of the taxIdValidator because the       */
    /* taxIdValidator will make sure the FEIN is 9 digits and we have        */
    /* testing accounts that use only 2 digit FEINs. This check will prevent */
    /* a generic server error when the user enters a FEIN that is too large. */
    /*-----------------------------------------------------------------------*/
    if ($ctrl.org.FEIN > 999999999)
      return Alert.error('Number is not valid', 'FEIN');

    BusyScreen.promise(
      Services.saveOrganization($ctrl.org).then(
        function (resp) {
          Alert.success('Information Saved');
        },
        function (resp) {
          Alert.error(
            resp.parsedResponse
              ? resp.parsedResponse.message()
              : resp.statusText,
            'Cannot Save'
          );
        }
      )
    );
  };
}

/*****************************************************************************
 * $ctrl.taxRateDisplay */
/**
 * @ngdoc    function
 * @name     taxRateDisplay
 * methodOf  csm.books.OurOrg.controller.OrgController
 * @param    value  displayed value
 *
 * @description
 * Returns taxrate in percent form (e.g. 8.75%) and sets it in decimal form
 * (e.g. 0.0875). Also need to make sure the value is a number. This is done
 * because !value returns false when the value is zero and sets the sales tax
 * to the previous amount, but we actually want to there are times where we
 * want to set the sales tax to zero. We also don't want the sales tax to be
 * more than 100 percent.
 *****************************************************************************/
/* @ngInject */ function taxRateDisplay($ctrl, Tools) {
  return function (value) {
    if (typeof value !== 'number' || value > 100)
      return !$ctrl.org
        ? null
        : Tools.roundToPrecision($ctrl.org.taxRate * 100, 2);

    $ctrl.org.taxRate = Tools.roundToPrecision(value / 100, 4);
  };
}
